<template>
  <div>
    <small>{{ charCount }}/{{ limit }} Zeichen</small>
  </div>
</template>

<script>
export default {
  name: 'CharCounter',
  props: {
    limit: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    charCount() {
      return this.text.length;
    }
  }
};
</script>

<style scoped>
p {
  font-size: 16px;
  color: #333;
}
</style>
